import { useQuery } from '@apollo/client';
import { GET_OPTIONS_TALENT } from '@gql/options';
import { createContext, useContext } from 'react';

const OptionsContext = createContext(null);

export const OptionsProvider = ({ children }) => {
    const { data, loading, error } = useQuery(GET_OPTIONS_TALENT);

    return (
        <OptionsContext.Provider value={{ data, loading, error }}>
            {children}
        </OptionsContext.Provider>
    );
};

export const useOptionsContext = () => {
    const context = useContext(OptionsContext);
    if (!context) {
        throw new Error('useOptionsContext must be used within an OptionsProvider');
    }
    return context;
};

